"use strict";
/*
 * @Author: ’‘
 * @Date: 2022-04-14 10:26:36
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-06-30 10:48:58
 * @FilePath: /activity_cfhd_a20220702mact/utils.ts
 * @Description:
 */
/*
 * @LastEditors: ’‘
 * @Date: 2022-01-10 15:07:56
 * @LastEditTime: 2022-04-13 22:22:38
 * @Descripttion:
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWX = exports.doAmsSubmit = exports.giftConfig = exports.loadTab = exports.handleNormalBtnClassAndAmsSbumit = exports.btnGrayNormalHandle = exports.support2Ams = exports.zalert = exports.copyText = exports.getUrlParam = exports.initShareFunc = exports.giftRecord = void 0;
// declare function jQuery( cb: Function ): any;
function copyText(text, callback) {
    var tag = document.createElement('input');
    tag.setAttribute('id', 'cp_hgz_input');
    tag.value = text;
    document.getElementsByTagName('body')[0].appendChild(tag);
    document.getElementById('cp_hgz_input').select();
    document.execCommand('copy');
    document.getElementById('cp_hgz_input').remove();
    if (typeof callback == 'function') {
        callback();
    }
}
exports.copyText = copyText;
function getUrlParam(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var r = window.location.search.substr(1).match(reg);
    if (r != null)
        return unescape(r[2]);
    return null;
}
exports.getUrlParam = getUrlParam;
function zalert(msg, confirmCallback) {
    need('util.modalDialog', function (Dialog) {
        Dialog.alert(msg, {
            onConfirm: confirmCallback
        });
    });
}
exports.zalert = zalert;
// 是否是手Q内打开
function isQQ() {
    return / qq\//i.test(navigator.userAgent);
}
// 是否是手Q内打开
function isWX() {
    return /MicroMessenger/gi.test(navigator.userAgent);
}
exports.isWX = isWX;
function initShareFunc(pcUrl, h5Url, title, desc, summary, iconPic, pcQrcodeCfg, h5popId) {
    var sharePCUrl = pcUrl || window.location.href;
    var shareMobileUrl = h5Url || window.location.href;
    // 如果在wx和QQ的环境内，应该直接执行sth
    if (isWX() || isQQ())
        sth(shareMobileUrl, '', title, desc, iconPic);
    var shareH5 = function () {
        sth(shareMobileUrl, h5popId, title, desc, iconPic);
    };
    var shareZone = function () {
        //$(".dialog").fadeOut();
        need('biz.qzoneShare', function (share) {
            share.share({
                url: sharePCUrl,
                title: title,
                desc: desc,
                pics: iconPic,
                summary: summary,
                showcount: '0',
                md: '1',
                callback: function (shareId) {
                    zalert('分享成功！', function () { });
                }
            });
        });
        closeDialog();
    };
    var shareQQ = function () {
        var p = {
            url: shareMobileUrl,
            /*获取URL，可加上来自分享到QQ标识，方便统计*/
            desc: desc,
            /*分享理由(风格应模拟用户对话),支持多分享语随机展现（使用|分隔）*/
            title: title,
            /*分享标题(可选)*/
            summary: summary,
            pics: iconPic,
            /*分享图片(可选)*/
            flash: '',
            site: '',
            style: '201',
            width: 32,
            height: 32
        };
        var s = [];
        for (var i in p) {
            s.push(i + '=' + encodeURIComponent(p[i] || ''));
        }
        window.open('//connect.qq.com/widget/shareqq/index.html?' + s.join('&'), '');
    };
    if (pcQrcodeCfg != undefined && isPage != 'H5') {
        // 二维码
        milo.loadScript('//cfhd.cf.qq.com/cp/a20210817cfhdrlr/js/jquery.qrcode.min.js', function () {
            // var shareUrlPc =  'https://cfhd.cf.qq.com/cp/a20210512cfycj/index.html'
            $(pcQrcodeCfg.class).empty();
            jQuery(function () {
                ;
                jQuery(pcQrcodeCfg.class).qrcode({
                    width: pcQrcodeCfg.width,
                    height: pcQrcodeCfg.height,
                    text: shareMobileUrl
                });
            });
        });
    }
    function sth(url, popId, title, desc, iconPic) {
        var curHtmlUrl = window.location.href;
        if (new RegExp('cfapp').test(navigator.userAgent) || /GameHelper/.test(navigator.userAgent) || /cfapp/.test(navigator.userAgent)) {
            launchShareWindow(url, title, desc, iconPic);
            //}else if((curHtmlUrl.indexOf("djc") >= 0 || curHtmlUrl.indexOf("props") >= 0 || curHtmlUrl.indexOf("act") >= 0 || curHtmlUrl.indexOf("daojucheng") >= 0 || curHtmlUrl.indexOf("daoju") >= 0)&&curHtmlUrl.indexOf("sEncrypt") == -1){
        }
        else if (isWX() || isQQ()) {
            //初始化微信和手Q的分享组件
            TGMobileShare({
                shareTitle: title,
                shareDesc: desc,
                shareImgUrl: iconPic,
                shareLink: url,
                actName: 'a20211221reserve',
                wxAppId: 'wx4a6848ac08e18340',
                onInit: function (tgms) {
                    function func() {
                        var timeId = setTimeout(function () {
                            if (typeof window.WxjssdkWx === 'object') {
                                //todo
                                clearTimeout(timeId);
                            }
                            else {
                                func();
                            }
                        }, 50);
                    }
                    if (tgms.isWX) {
                        func();
                    }
                }
            });
            TGDialogS(popId);
        }
        else if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
            // 手机H5端 暂时不做处理
            alert('为了您的活动体验，请前往手机QQ或者微信参加~');
        }
    }
    function launchShareWindow(url, title, desc, iconPic) {
        var title = title, desc = desc, icon = iconPic;
        if (typeof GameHelper != 'undefined') {
            GameHelper.shareWebPageWithFuntion(title, desc, icon, url, '1,2,3,4,5', 1);
        }
        else {
            //zhtc();
            var comment_info = desc;
            var share_url = url;
            var title = title;
            var summary = desc;
            var icon = iconPic;
            var collect_state = 1;
            //掌上cf分享ios需要的函数
            var sendIosMessage = function (src) {
                var oIFrame = document.getElementById('__MessageIframe__');
                if (!oIFrame) {
                    oIFrame = document.createElement('iframe');
                    oIFrame.id = '__MessageIframe__';
                    oIFrame.frameborder = '0';
                    oIFrame.scrolling = 'no';
                    oIFrame.width = '0px';
                    oIFrame.height = '0px';
                    oIFrame.frameBorder = '0';
                    oIFrame.style.display = 'none';
                    oIFrame.src = src;
                    document.body.appendChild(oIFrame);
                }
                else {
                    oIFrame.src = src;
                }
            };
            //掌上cf分享安卓需要的函数
            var sendAndroidMessage = function (src) {
                window.location.href = src;
            };
            var data = {
                title: encodeURIComponent(title),
                summary: encodeURIComponent(summary),
                icon: encodeURIComponent(icon),
                is_act: encodeURIComponent('1'),
                url: encodeURIComponent(share_url),
                collect_state: encodeURIComponent(collect_state)
                //"shareopen" : encodeURIComponent("1")
            };
            var src = 'requestapp://sharenew?param=' + encodeURIComponent(JSON.stringify(data));
            if (new RegExp('cfapp').test(navigator.userAgent)) {
                if (new RegExp('Android').test(navigator.userAgent)) {
                    sendAndroidMessage(src);
                }
                else {
                    sendIosMessage(src);
                }
            }
        }
    }
    return {
        shareZone: shareZone,
        shareH5: shareH5,
        shareQQ: shareQQ
    };
}
exports.initShareFunc = initShareFunc;
function handleGiftCount(list) {
    list.map(function (ele) {
        // console.log(ele.sPackageName)
        // console.log(!ele.sPackageName.search(/\*[0-9]/))
        if (parseInt(ele.iPackageNum) > 1 && ele.sPackageName.search(/\*/) < 0) {
            ele.sPackageName += '*' + ele.iPackageNum;
        }
    });
    return list;
}
// 礼包记录 传入 ams的流程id   和  绑定函数的 dom
function giftRecord(isPageType, iActivityId, giftId, flowId, btnDomStr) {
    if (flowId == undefined || flowId == '' || flowId == '0') {
        console.error('引入功能：', '错误，请传入flowId');
        return;
    }
    if (btnDomStr == undefined || btnDomStr == '' || btnDomStr == '0') {
        console.error('引入功能：', '错误，请传入dom绑定按钮');
        return;
    }
    var amsCfg = 'amsCfg_' + flowId;
    if (isPageType == 'H5') {
        // 个人获奖记录初始化
        window[amsCfg] = {
            activityId: iActivityId,
            flowId: flowId,
            moduleId: giftId,
            cache: false,
            extParam: {
                pageNo: 1,
                pageSize: 6
            },
            //提交成功的回调 （必选）
            success: function (data) {
                handleGiftCount(data.myGiftList);
                // console.log(data)
                //获取模块接口对象
                var giftModule = window['myGiftList_' + flowId];
                need(['util.zepto', 'util.template', 'biz.widget.dialog'], function ($, TemplateManager, widget) {
                    //如果第一次点击，则先显示弹出框，在渲染页面
                    if ($('#tbody_' + flowId).length == 0) {
                        widget.dialog({
                            content: $('#tpl_dialog_' + flowId).html(),
                            width: 350,
                            onSuccess: function () {
                                giftModule.renderPanel(data);
                            }
                        });
                    }
                    else {
                        //如果是翻页的情况，直接渲染页面
                        giftModule.renderPanel(data);
                    }
                });
            }
        };
        milo.ready(function () {
            need(['util.zepto', 'biz.login'], function ($, LoginManager) {
                $(btnDomStr).click(function () {
                    amsSubmit(iActivityId, flowId);
                });
            });
        });
    }
    else {
        var amsCfg = 'amsCfg_' + flowId;
        // 个人获奖记录初始化
        window[amsCfg] = {
            activityId: iActivityId,
            flowId: flowId,
            moduleId: giftId,
            cache: false,
            extParam: {
                pageNo: 1,
                pageSize: 8
            },
            //提交成功的回调 （必选）
            success: function (data) {
                // console.log('data111', data)
                handleGiftCount(data.myGiftList);
                // console.log(newList)
                // console.log(newList)
                // data.myGiftList = newList
                //获取模块接口对象
                var giftModule = window['myGiftList_' + flowId];
                need(['util.jquery', 'util.template', 'biz.widget.base'], function ($, TemplateManager, widget) {
                    //如果第一次点击，则先显示弹出框，在渲染页面
                    if ($('#tbody_' + flowId).length == 0) {
                        widget.dialog({
                            content: $('#tpl_dialog_' + flowId).html(),
                            width: 600,
                            topOffset: -200,
                            complete: function () {
                                giftModule.renderPanel(data);
                            }
                        });
                    }
                    else {
                        //如果是翻页的情况，直接渲染页面
                        giftModule.renderPanel(data);
                    }
                });
            }
        };
        milo.ready(function () {
            need(['util.jquery', 'biz.login', 'biz.widget.base'], function ($, LoginManager, widget) {
                $(btnDomStr).click(function () {
                    amsSubmit(iActivityId, flowId);
                });
            });
        });
    }
    var pcTemplate = '<script id="tpl_dialog_' +
        flowId +
        '" type="text/tempalate">' +
        '<p class="p_tips_bar"><strong>温馨提示</strong>：虚拟道具奖品将在24小时内发到您的游戏内仓库，请耐心等候，谢谢您的理解与支持！</p>' +
        '<table class="lz_act_pop_table"><thead><tr><th style="width:25%">获奖时间</th><th style="width:25%">所获礼包</th></tr></thead>' +
        '<tbody id="tbody_' +
        flowId +
        '"></tbody>' +
        '<tfoot id="tfoot_' +
        flowId +
        '"></tfoot>' +
        '</table></script>' +
        '<!--表单内容主体模板--><script id="tpl_tbody_' +
        flowId +
        '" type="text/tempalate">{if pageData.iRet!="0"}<tr><td colspan="4" align="center">${pageData.sMsg}</td></tr>' +
        '{else}{for giftInfo in pageData.myGiftList }<tr><td>${giftInfo.dtGetPackageTime}</td><td>${giftInfo.sPackageName}</td></tr>' +
        '{forelse}<tr><td colspan="4" align="center">您尚未获得任何礼包</td></tr>{/for}{/if}</script>' +
        '<!--底部翻页模板--><script id="tpl_tfoot_' +
        flowId +
        '" type="text/tempalate">' +
        '<tr><td class="page" colspan="4"><a href="javascript:void(0);" id="prevbtn_' +
        flowId +
        '" title="上一页">上一页</a>' +
        '<span class="page_num"><em class="now_page"  id="currPage_' +
        flowId +
        '">${pageData.pageNow}</em class="total_page" id="totalPage_' +
        flowId +
        '">/<em>${pageData.pageTotal}</em></span>' +
        '<a href="javascript:void(0);"  id="nextbtn_' +
        flowId +
        '" title="下一页">下一页</a></td></tr></script>';
    var h5Template = '<style type="text/css">.amsmobi_dialog{top:30% !important;width:80% !important}.p_tips_bar{font-size: 12px;text-align: left;}.lz_act_pop_table {width: 100%;}tr th:first-child{ width: 50%; }tr th:last-child{ width: 25%; }tr td{padding: 5px 0px;}.lz_act_pop_table .page{padding-top: 10px;}</style>' +
        '<!--对话框容器模板--><script id="tpl_dialog_' +
        flowId +
        '" type="text/tempalate"><p class="p_tips_bar"><strong>温馨提示</strong>：虚拟道具奖品将在24小时内发到您的游戏内仓库，请耐心等候，谢谢您的理解与支持！</p>' +
        '<table class="lz_act_pop_table"><thead><tr><th>获奖时间</th><th>所获礼包</th><!--th>ios/android</th--></tr></thead>' +
        '<tbody id="tbody_' +
        flowId +
        '"></tbody><tfoot id="tfoot_' +
        flowId +
        '"></tfoot></table></script>' +
        '<!--表单内容主体模板--><script id="tpl_tbody_' +
        flowId +
        '" type="text/tempalate">{if pageData.iRet!="0"}<tr><td colspan="3" align="center">${pageData.sMsg}</td></tr>' +
        '{else}{for giftInfo in pageData.myGiftList }<tr><td>${giftInfo.dtGetPackageTime}</td><td>${giftInfo.sPackageName}</td></tr>' +
        '{forelse}<tr><td colspan="3" align="center">您尚未获得任何礼包</td></tr>{/for}{/if}</script>' +
        '<!--底部翻页模板--><script id="tpl_tfoot_' +
        flowId +
        '" type="text/tempalate"><tr><td class="page" colspan="3"><a href="javascript:void(0);" id="prevbtn_' +
        flowId +
        '" title="上一页">上一页</a>' +
        '<span class="page_num"><em class="now_page"  id="currPage_' +
        flowId +
        '">${pageData.pageNow}</em class="total_page" id="totalPage_' +
        flowId +
        '">/<em>${pageData.pageTotal}</em></span>' +
        '<a href="javascript:void(0);"  id="nextbtn_' +
        flowId +
        '" title="下一页">下一页</a></td></tr></script>';
    if (isPage == 'H5') {
        $('script:last').after(h5Template);
    }
    else {
        $('script:last').after(pcTemplate);
    }
}
exports.giftRecord = giftRecord;
function realGoodGift(iPageType, iActivityId, flowId, domStr) {
    var amsCfg = 'amsCfg_' + flowId;
    if (iPageType == 'H5') {
        var h5Template = '<style>.donsonClass{background: #fff !important; top: 35% !important; left: 40% !important ;width: 54% !important;font-size: 18px;height:700px !important; padding-left: 40px !important;padding-top: 40px !important;}</style>' +
            '<style type="text/css">.defaultContent{display: block;	width: 300px;z-index: 4201;top: 50%;left: 50%;position: fixed;margin-left: -150px;margin-top: -221.5px;background-color: #fff;	text-align: center;	-moz-border-radius: 8px;-webkit-border-radius: 8px;	border-radius: 8px;	box-shadow: rgb(178, 178, 178) 0px -1px 1px -1px inset;	}.defaultContent form{padding: 20px;}.defaultContent .star{color: #f00;}' +
            '.defaultContent .submitBtn{display:block;width: 120px;height: 40px;background: url(http://ossweb-img.qq.com/images/cf/act/a20100610wcg/pIsubmitBtn.jpg) no-repeat 0px 0px;margin: 20px auto 0px auto;}.defaultContent table td{text-align: left;}</style>' +
            '<!-- 填写个人信息 html --><div id="personInfoContent_' +
            flowId +
            '" class="defaultContent donsonClass" style="display:none;">' +
            '<form id="form_personInfo_' +
            flowId +
            '" name="form_personInfo_' +
            flowId +
            '"><header><a href="###" id="colseLayer_' +
            flowId +
            '" style="float: right;">关闭</a></header>' +
            '<section style="clear: both;"><table class="lz_act_pop_table"><tbody><tr style="display:none;" id="tr_package_name_' +
            flowId +
            '"><td><span class="star">*</span> 所获实物：</td></tr>' +
            '<tr style="display:none;" id="tr_package_value_' +
            flowId +
            '"><td><select name="sPackageInfo" id="package_' +
            flowId +
            '"></select></td></tr>' +
            '<tr><td><span class="star">* </span>姓名：</td></tr><tr><td><input name="sName" type="text" /></td></tr>' +
            // <tr>
            // 	<td>
            // 		<span class="star"> </span>性别：
            // 	</td>
            // </tr>
            // <tr>
            // 	<td>
            // 		<label for="sMale"><input type="radio" checked="checked" style="width: 14px;" value="male" id="sMale" name="sGender" />男</label>
            // 		<label for="sFemale" ><input type="radio" value="female" style="width: 14px;" id="sFemale"  name="sGender"  />女</label>
            // 	</td>
            // </tr>
            '<tr><td><span class="star">* </span>身份证号码：</td></tr><tr><td><input name="sIdentity" type="text" /></td></tr>' +
            '<tr><td><span class="star">* </span>手机号码：</td></tr><tr><td><input name="sMobile" type="text" /></td></tr>' +
            '<tr><td><span class="star">* </span>所在城市：</td></tr><tr><td><select name="sProvince" id="province_' +
            flowId +
            '"  style="width:100px;"></select><select name="sCity" id="city_' +
            flowId +
            '"  style="width:100px;"></select><select name="sExtend2" id="county_' +
            flowId +
            '"  style="width:100px;"></select></td></tr>' +
            '<tr><td><span> </span>邮政编码：</td></tr><tr><td><input name="sPostCode" type="text" /></td></tr>' +
            '<tr><td><span class="star">* </span>详细地址：</td></tr><tr><td><input name="sAddress" type="text" /></td></tr><tr><td>发货订单：<span id="sExtend1_' +
            flowId +
            '">暂无</span></td></tr>' +
            '</tbody></table></section><footer><a href="###" id="personInfoContentBtn_' +
            flowId +
            '" class="submitBtn"></a></footer></form></div>';
        //提交个人信息
        window[amsCfg] = {
            iActivityId: iActivityId,
            iFlowId: flowId,
            _everyRead: true,
            success: function (res) {
                //提交成功的回调
                if (typeof res.jData == 'object') {
                    //返回已经提交的数据，填充页面
                    need(['biz.provincecityselector2', 'util.form'], function (pcs, FormManager) {
                        //显示弹出框
                        g('personInfoContent_' + flowId).style.display = 'block';
                        //关闭弹出框
                        g('colseLayer_' + flowId).onclick = function () {
                            g('personInfoContent_' + flowId).style.display = 'none';
                        };
                        //提交按钮事件
                        g('personInfoContentBtn_' + flowId).onclick = function () {
                            var fillData = FormManager.getAllInputValue('form_personInfo_' + flowId);
                            for (var i in fillData) {
                                var _val = fillData[i];
                                switch (i) {
                                    case 'sName': {
                                        if (!_val) {
                                            alert('姓名不能为空');
                                            return false;
                                        }
                                        if (milo.getByteLength(_val) > 30) {
                                            alert('姓名长度不能超过30个字节。');
                                            return false;
                                        }
                                        break;
                                    }
                                    case 'sIdentity': {
                                        if (!_val) {
                                            alert('身份证号码不能为空');
                                            return false;
                                        }
                                        if (!milo.isIDCard(_val)) {
                                            alert('身份证号码有误。');
                                            return false;
                                        }
                                        break;
                                    }
                                    case 'sMobile': {
                                        if (!_val) {
                                            alert('手机号码不能为空');
                                            return false;
                                        }
                                        if (isNaN(_val) || _val.indexOf('.') >= 0) {
                                            alert('手机号码必须为数字。');
                                            return false;
                                        }
                                        if (_val.length > 11) {
                                            alert('手机号码不得超过11位。');
                                            return false;
                                        }
                                        break;
                                    }
                                    case 'sAddress': {
                                        if (!_val) {
                                            alert('详细地址不能为空');
                                            return false;
                                        }
                                        if (milo.getByteLength(_val) > 100) {
                                            alert('详细地址不能超过100个字节。');
                                            return false;
                                        }
                                        break;
                                    }
                                    default: {
                                    }
                                }
                            }
                            window[amsCfg].sData = fillData;
                            amsSubmit(iActivityId, flowId);
                        };
                        var pcsConfig = {
                            provinceId: 'province_' + flowId,
                            cityId: 'city_' + flowId,
                            areaId: 'county_' + flowId,
                            initVal: []
                        };
                        if (res.jData.sProvince && res.jData.sCity && res.jData.sExtend2) {
                            pcsConfig.initVal = [res.jData.sProvince, res.jData.sCity, res.jData.sExtend2];
                        }
                        pcs.show(pcsConfig);
                        //发货订单:
                        if (res.jData.sExtend1) {
                            g('sExtend1_' + flowId).innerHTML = res.jData.sExtend1;
                        }
                        delete res.jData.sProvince;
                        delete res.jData.sCity;
                        FormManager.setAllInputValue(res.jData, 'form_personInfo_' + flowId);
                        if (typeof res.jData.arrPackageInfo != 'undefined' && res.jData.arrPackageInfo.length > 0) {
                            //如果存在实物信息，则显示
                            g('tr_package_name_' + flowId).style.display = '';
                            g('tr_package_value_' + flowId).style.display = '';
                            for (var i = 0; i < res.jData.arrPackageInfo.length; ++i) {
                                var iPackageId = res.jData.arrPackageInfo[i].iPackageId;
                                var sPackageName = res.jData.arrPackageInfo[i].sPackageName;
                                g('package_' + flowId).options[i] = new Option(sPackageName, iPackageId + '|' + sPackageName);
                            }
                        }
                    });
                }
                else {
                    need(['biz.widget.dialog'], function (Dialog) {
                        Dialog.alert(res.sMsg);
                    });
                }
            }
        };
        milo.ready(function () {
            need(['biz.login'], function (LoginManager) {
                //填写按钮的点击事件绑定
                $(domStr).click(function () {
                    LoginManager.submitLogin(function () {
                        window[amsCfg].sData = {
                            iShow: 1
                        };
                        amsSubmit(iActivityId, flowId);
                    });
                });
            });
        });
        $('script:last').after(h5Template);
    }
    else {
        var pcTemplate = '<style>.donsonClass{background: #fff !important; left: 40% !important ;width: 50%;font-size: 18px;height:700px !important; padding-left: 40px !important;padding-top: 40px !important;}</style>' +
            '<div id="personInfoContent_' +
            flowId +
            '" class="defaultContent donsonClass" style="display:none;"><a href="javascirpt:;" id="colseLayer_' +
            flowId +
            '">关闭</a><p>个人信息填写:为保证实物奖励能准确邮寄，下面所有项目务必详细填写！<span>未获得实物奖励请勿填写</span></p>' +
            '<form id="user_userInfoform_' +
            flowId +
            '" name="user_userInfoform_' +
            flowId +
            '">' +
            '<table width="422" cellspacing="0" cellpadding="0" border="0"><tbody><tr style="display:none;" id="tr_package_' +
            flowId +
            '"><td><span>*</span> 所获实物：</td><td><select name="sPackageInfo" id="package_' +
            flowId +
            '"></select></td></tr><tr><td><span>*</span>' +
            '姓名：</td><td><input name="sName" type="text"></td></tr>' +
            // <tr><td><span>*</span> 性别：</td>
            // <td>
            // 					<label>男：<input style="width:14px;" name="sGender" value="male" type="radio" checked="checked"></label>
            // 					<label>女：<input style="width:14px;" name="sGender" value="female" type="radio"></label>
            // 				</td>
            // 			</tr>
            '<tr><td><span>*</span> 身份证号码：</td><td><input name="sIdentity" type="text"></td></tr>' +
            '<tr><td><span>*</span> 手机号码：</td><td><input name="sMobile" type="text"></td></tr>' +
            '<tr><td><span>*</span> 省份：</td><td><select name="sProvince" id="province_' +
            flowId +
            '" type="text"></select></tr>' +
            '<tr><td><span>*</span> 城市：</td><td><select name="sCity" id="city_' +
            flowId +
            '" type="text"></select></tr>' +
            '<tr><td><span>*</span> 区/县：</td><td><select name="sExtend2" id="county_' +
            flowId +
            '" type="text"></select></tr>' +
            '<tr><td><span>*</span> 详细地址：</td><td><input name="sAddress" type="text"></td></tr>' +
            '<tr><td><span>*</span> 邮编：</td><td><input name="sPostCode" type="text"></td></tr>' +
            '<tr><td>发货订单：</td><td><span id="sExtend1_' +
            flowId +
            '">暂无</span></td></tr>' +
            '<tr><td></td><td><a href="###" style="display:block;" id="personInfoContentBtn_' +
            flowId +
            '" class="submitBtn">提交订单</a></td></tr>' +
            '</tbody></table></form></div>';
        window[amsCfg] = {
            iActivityId: iActivityId,
            iFlowId: flowId,
            _everyRead: true,
            fFlowSubmitEnd: function (res) {
                if (typeof res.jData == 'object') {
                    //返回已经提交的数据，填充页面
                    need(['biz.provincecityselector2', 'biz.dialog', 'util.form'], function (pcs, Dialog, FormManager) {
                        Dialog.show({
                            id: 'personInfoContent_' + flowId + ''
                        });
                        g('personInfoContentBtn_' + flowId + '').onclick = function () {
                            var fillData = FormManager.getAllInputValue('personInfoContent_' + flowId + '');
                            for (var i in fillData) {
                                var _val = fillData[i];
                                switch (i) {
                                    case 'sName': {
                                        if (!_val) {
                                            alert('姓名不能为空');
                                            return;
                                        }
                                        if (milo.getByteLength(_val) > 30) {
                                            alert('姓名长度不能超过30个字节。');
                                            return;
                                        }
                                        break;
                                    }
                                    // case 'sGender':{
                                    //   if(!_val){alert("性别必须选择"); return;}
                                    //   break;
                                    // }
                                    case 'sIdentity': {
                                        if (!_val) {
                                            alert('身份证号码不能为空');
                                            return;
                                        }
                                        if (!milo.isIDCard(_val)) {
                                            alert('身份证号码有误。');
                                            return;
                                        }
                                        break;
                                    }
                                    case 'sMobile': {
                                        if (!_val) {
                                            alert('手机号码不能为空');
                                            return;
                                        }
                                        if (isNaN(_val) || _val.indexOf('.') >= 0) {
                                            alert('手机号码必须为数字。');
                                            return;
                                        }
                                        if (_val.length > 11) {
                                            alert('手机号码不得超过11位。');
                                            return;
                                        }
                                        break;
                                    }
                                    case 'sAddress': {
                                        if (!_val) {
                                            alert('详细地址不能为空');
                                            return;
                                        }
                                        if (milo.getByteLength(_val) > 100) {
                                            alert('详细地址不能超过100个字节。');
                                            return;
                                        }
                                        break;
                                    }
                                    case 'sPostCode': {
                                        if (!_val) {
                                            alert('邮政编码不能为空');
                                            return;
                                        }
                                        if (milo.getByteLength(_val) > 8) {
                                            alert('邮政编码不能超过8个字节。');
                                            return;
                                        }
                                        if (isNaN(_val) || _val.indexOf('.') >= 0) {
                                            alert('邮政编码必须为数字。');
                                            return;
                                        }
                                        break;
                                    }
                                    case 'sProvince': {
                                        if (!_val) {
                                            alert('请选择省份');
                                            return;
                                        }
                                        break;
                                    }
                                    case 'sCity': {
                                        if (!_val) {
                                            alert('请选择城市');
                                            return;
                                        }
                                        break;
                                    }
                                    case 'sExtend2': {
                                        if (!_val) {
                                            alert('请选择区/县');
                                            return;
                                        }
                                        break;
                                    }
                                    default: {
                                    }
                                }
                            }
                            window[amsCfg].sData = fillData;
                            amsSubmit(iActivityId, flowId);
                        };
                        g('colseLayer_' + flowId).onclick = function () {
                            Dialog.hide();
                        };
                        if (g('province_' + flowId).innerHTML != '') {
                            g('province_' + flowId).innerHTML = '';
                        }
                        if (g('city_' + flowId).innerHTML != '') {
                            g('city_' + flowId).innerHTML = '';
                        }
                        if (g('county_' + flowId).innerHTML != '') {
                            g('county_' + flowId).innerHTML = '';
                        }
                        var pcsConfig = {
                            provinceId: 'province_' + flowId,
                            cityId: 'city_' + flowId,
                            areaId: 'county_' + flowId,
                            initVal: []
                        };
                        if (res.jData.sProvince && res.jData.sCity && res.jData.sExtend2) {
                            pcsConfig.initVal = [res.jData.sProvince, res.jData.sCity, res.jData.sExtend2];
                        }
                        pcs.show(pcsConfig);
                        //发货订单:
                        if (res.jData.sExtend1) {
                            g('sExtend1_' + flowId).innerHTML = res.jData.sExtend1;
                        }
                        delete res.jData.sProvince;
                        delete res.jData.sCity;
                        FormManager.setAllInputValue(res.jData, 'personInfoContent_' + flowId + '');
                        if (typeof res.jData.arrPackageInfo != 'undefined' && res.jData.arrPackageInfo.length > 0) {
                            document.getElementById('tr_package_' + flowId).style.display = '';
                            var package_id = document.getElementById('package_' + flowId);
                            for (var i = 0; i < res.jData.arrPackageInfo.length; ++i) {
                                var iPackageId = res.jData.arrPackageInfo[i].iPackageId;
                                var sPackageName = res.jData.arrPackageInfo[i].sPackageName;
                                package_id.options[i] = new Option(sPackageName, iPackageId + '|' + sPackageName);
                            }
                        }
                    });
                }
                else {
                    alert(res.sMsg);
                }
            }
        };
        milo.ready(function () {
            $(domStr).click(function () {
                LoginManager.submitLogin(function () {
                    window[amsCfg].sData = {
                        iShow: 1
                    };
                    amsSubmit(iActivityId, flowId);
                });
            });
        });
        $('script:last').after(pcTemplate);
    }
}
function support2Ams() {
    var amsCfg = 'amsCfg_839141';
    window[amsCfg] = {
        _everyRead: true,
        iActivityId: 449749,
        iFlowId: 839141,
        sNeedSubmitPopDiv: false,
        sData: {
        //自定义传参
        },
        fFlowSubmitEnd: function (res) {
            return;
        },
        fFlowSubmitFailed: function (res) {
            //失败会走到这个函数
            setTimeout(function () {
                amsSubmit(449749, 839141);
            }, 10000);
        }
    };
    console.log('上报数据');
    amsSubmit(449749, 839141);
}
exports.support2Ams = support2Ams;
function btnGray(zigeNum, ele, grayClassName) {
    var maxCount = parseInt(ele.maxCount) || 1;
    var className = ele.grayClass || ele.class;
    if (parseInt(zigeNum) === maxCount)
        $(className).addClass(grayClassName);
}
function btnGrayNormalHandle(cfhdCallbackObj, btnClassList, grayClassName) {
    btnClassList &&
        btnClassList.forEach(function (ele) {
            if (cfhdCallbackObj[ele.key] && !ele.notNeedGray) {
                btnGray(cfhdCallbackObj[ele.key].split(',')[ele.postion], ele, grayClassName);
            }
        });
}
exports.btnGrayNormalHandle = btnGrayNormalHandle;
function handleNormalBtnClassAndAmsSbumit(btnClassList, iActivityId, doAmsActionDonson, initFunction, initFlowId) {
    if (!btnClassList || btnClassList.length < 1) {
        console.error('引入功能：', '正确使用！');
        return;
    }
    btnClassList.forEach(function (ele, index) {
        // 初始进入访问AMS 后续不再访问
        var actionDonson = function () {
            //  绑定AMS事件和AMS成功回调
            var resolve = function (callbackObj) {
                var needInitSubmit = false;
                if (ele.needInitSubmit != undefined)
                    needInitSubmit = ele.needInitSubmit;
                // 有回调的话，执行回调，不然就默认alert
                if (ele.resolve)
                    ele.resolve(callbackObj);
                else
                    alert(callbackObj.sMsg);
                //  动作执行成功后，不再请求AMS初始化，直接初始化
                if (!ele.needInitSubmit && parseInt(callbackObj.iRet) == 0 && ele.key && window.cfhdCallbackObj[ele.key] && window.cfhdCallbackObj[ele.key].length > 0) {
                    // 先处理好资格变化
                    if (ele.postion != undefined) {
                        // 有具体位置处理资格，不然就直接处理整个 output变化
                        var zigeList = window.cfhdCallbackObj[ele.key].split(',');
                        var newNum = parseInt(zigeList[ele.postion]) + 1;
                        zigeList[ele.postion] = newNum;
                        window.cfhdCallbackObj[ele.key] = zigeList.join(',');
                    }
                    else if (callbackObj[ele.key]) {
                        // 如果返回有相同的key 会进行覆盖
                        // 没有或者想偷懒 直接不传比较好
                        ;
                        window.cfhdCallbackObj[ele.key] = callbackObj[ele.key];
                    }
                    else {
                        console.error('你可能已经填错啦~');
                    }
                    // 执行初始化的js
                    initFunction(window.cfhdCallbackObj);
                }
                else {
                    OutPutDonson('init', initFunction);
                }
            };
            var before = ele.before ||
                function () {
                    return true;
                };
            var iAmsId = 0;
            if (ele.config && ele.config.iActivityId)
                iAmsId = ele.config.iActivityId;
            else
                iAmsId = iActivityId;
            doAmsActionDonson(iAmsId, ele.flowId, resolve, ele.reject, ele.params, true, before, ele.config);
        };
        $(ele.class).unbind('click');
        if (ele.postion)
            window['func_' + iActivityId + '_' + ele.flowId + '_' + ele.postion] = actionDonson;
        else
            window['func_' + iActivityId + '_' + ele.flowId + '_0'] = actionDonson;
        if (!ele.notNeedSubmit && $(ele.class).length > 0)
            $(ele.class).click(actionDonson);
        else
            console.log('此class未绑定,或不需要立即提交：', ele.class, ele);
    });
    function OutPutDonson(handleType, initFunc) {
        if (!initFunc) {
            console.error('引入功能：', '必须写初始化函数');
        }
        if (handleType === 'init') {
            console.log(iActivityId);
            doAmsActionDonson(iActivityId, initFlowId, initFunc, '', '', false, function () {
                return true;
            }, '');
        }
        else {
            initFunc(window.cfhdCallbackObj);
        }
    }
}
exports.handleNormalBtnClassAndAmsSbumit = handleNormalBtnClassAndAmsSbumit;
//  amsCfg自动生成
function giftConfig(iActivityId, giftId, flowId, OutPutDonson, initFunction, resolve, reject, params, pop, config) {
    if (params === void 0) { params = {}; }
    if (pop === void 0) { pop = true; }
    if (config === void 0) { config = { iActivityId: '', giftId: '' }; }
    var sData = {};
    // var initFunc
    var resolveFunc;
    var rejectFunc;
    var popMask = pop;
    if (params && typeof params == 'object' && Object.keys(params).length > 0) {
        Object.keys(params).forEach(function (ele) {
            sData[ele] = params[ele];
        });
        // sData = JSON.parse(JSON.stringify(params));
    }
    if (resolve != undefined && resolve !== '')
        resolveFunc = resolve;
    else {
        resolveFunc = function (callbackObj) {
            alert(callbackObj.sMsg);
            OutPutDonson('init', initFunction);
        };
    }
    if (reject != undefined && reject !== '')
        rejectFunc = reject;
    else {
        rejectFunc = function (callbackObj) {
            support2Ams();
            if (callbackObj.iRet == '202') {
                TGDialogS('pop4');
            }
            else if (callbackObj.sMsg === '抱歉，您还没有角色，无法参与~' || callbackObj.sMsg === '抱歉，您还未拥有角色，无法参与~') {
                // 拉起来预创角
                TGDialogS('pop3');
            }
            else if (callbackObj.sMsg == '当前大区角色不存在，请重新选择~') {
                alert(callbackObj.sMsg);
            }
            else {
                alert(callbackObj.sMsg);
            }
        };
    }
    var flowCfg = 'amsCfg_' + flowId;
    console.log(flowCfg);
    window[flowCfg] = {
        iAMSActivityId: config.iActivityId || iActivityId,
        activityId: config.giftId || giftId,
        sData: sData,
        _everyRead: true,
        sNeedSubmitPopDiv: popMask,
        onBeginGetGiftEvent: function () {
            return 0; // 抽奖前事件，返回0表示成功
        },
        onGetGiftFailureEvent: function (callbackObj) {
            // 抽奖失败事件
            rejectFunc(callbackObj);
            return;
        },
        onGetGiftSuccessEvent: function (callbackObj) {
            // 抽奖成功事件
            resolveFunc(callbackObj);
            return;
        }
    };
}
exports.giftConfig = giftConfig;
function request(url, method) {
    return new Promise(function (resolve, reject) {
        // 获取 XMLHttpRequest 对象的实例
        var xhr = new XMLHttpRequest();
        xhr.overrideMimeType('text/html;charset=gb2312');
        xhr.open(method, url);
        xhr.send(null);
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                /**
                 * http 状态码在 200 的区间都是请求成功的状态
                 * 状态码 304 表示缓存文件
                 */
                if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 304) {
                    // console.log(xhr)
                    var template = xhr.responseText;
                    resolve(template);
                }
                else {
                    console.log('request was unsuccessful:' + xhr.status);
                    reject('fail');
                }
            }
        };
    });
}
function loadScript(url, charset) {
    if (charset === void 0) { charset = 'gbk'; }
    return new Promise(function (resolve, reject) {
        var _script = document.createElement('script');
        _script.setAttribute('charset', charset);
        _script.setAttribute('type', 'text/javascript');
        _script.setAttribute('src', url);
        document.getElementsByTagName('head')[0].appendChild(_script);
        var timeout = setTimeout(function () {
            reject('timeout'); //rejected
        }, 5000);
        _script.onload = function () {
            //加载完成
            clearTimeout(timeout);
            resolve(''); //fulfilled
        };
        _script.onerror = function () {
            //加载失败
            reject('fail'); //rejected
        };
    });
}
function loadStyle(url) {
    return new Promise(function (resolve, reject) {
        var _style = document.createElement('style');
        // _style.setAttribute('charset', 'utf-8')
        // rel="stylesheet"
        _style.setAttribute('rel', 'stylesheet');
        _style.setAttribute('href', url);
        document.getElementsByTagName('head')[0].appendChild(_style);
        var timeout = setTimeout(function () {
            reject('timeout'); //rejected
        }, 5000);
        _style.onload = function () {
            //加载完成
            clearTimeout(timeout);
            resolve(''); //fulfilled
        };
        _style.onerror = function () {
            //加载失败
            reject('pull fail'); //rejected
        };
    });
}
function loadTab(_a) {
    var container = _a.container, html = _a.html, js = _a.js, jsCharSet = _a.jsCharSet, _b = _a.css, css = _b === void 0 ? '' : _b;
    if (window.powerByMicroPageTab1) {
        console.log('已经加载过啦~');
    }
    else {
        ;
        window.powerByMicroPageTab1 = true;
        request(html, 'get').then(function (tpl) {
            $(container).empty();
            $(container).append(tpl);
            // console.log(tpl)
            loadScript(js, jsCharSet);
            if (css) {
                loadStyle(css);
            }
        });
    }
}
exports.loadTab = loadTab;
function doAmsSubmit(a, b, data) {
    var flowName = "amsCfg_".concat(b);
    if (window.flowName) {
        amsSubmit(a, b);
    }
    else {
        var sdata = JSON.parse(JSON.stringify(data));
        window[flowName] = {
            iAMSActivityId: a,
            activityId: giftId,
            sData: sdata,
            _everyRead: true,
            sNeedSubmitPopDiv: true,
            onBeginGetGiftEvent: function () {
                return 0; // 抽奖前事件，返回0表示成功
            },
            onGetGiftFailureEvent: function (callbackObj) {
                // 抽奖失败事件
                alert(callbackObj.sMsg);
                console.log(callbackObj);
                return;
            },
            onGetGiftSuccessEvent: function (callbackObj) {
                // 抽奖成功事件
                alert(callbackObj.sMsg);
                console.log(callbackObj);
                return;
            }
        };
    }
}
exports.doAmsSubmit = doAmsSubmit;
